import MuiIconButton from "@mui/material/IconButton";
import type { IconButtonProps } from "@mui/material/IconButton";
import XIcon from "components/Icons/XIcon";
import { useDialogContext } from "./Dialog";
import { composeEventHandlers } from "utils";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { styled } from "@mui/material";

const IconButton = styled(MuiIconButton)(() => ({
  position: "absolute",
  padding: 0,

  "&[data-size='sm']": {
    top: "8px",
    right: "16px",
  },
  "&[data-size='md']": {
    top: "16px",
    right: "24px",
  },
  "&[data-size='lg']": {
    top: "24px",
    right: "24px",
  },
  "&[data-size='full']": {
    top: "12px",
    right: "16px",
  },
  "&[data-fullscreen='true']": {
    top: "12px",
    right: "16px",
  },
}));

const iconFontSizeMapping = {
  sm: "medium",
  md: "medium",
  lg: "large",
  full: "large",
} as const;

function DialogClose(props: IconButtonProps) {
  const { onClick, ...rest } = props;
  const dialogContext = useDialogContext();
  const { t } = useTranslation();

  const iconFontSize = useMemo(() => iconFontSizeMapping[dialogContext.size], [dialogContext.size]);
  return (
    <IconButton
      size="small"
      aria-label={t("global.close_label")}
      {...rest}
      data-size={dialogContext.size}
      data-fullscreen={dialogContext.fullScreen}
      onClick={composeEventHandlers(onClick, dialogContext?.onClose)}
    >
      <XIcon fontSize={iconFontSize} htmlColor="#FFF" />
    </IconButton>
  );
}

export default DialogClose;
